import { MPCDeviceDetectionHelper } from "../helpers/deviceDetectionHelper";

export module MPCStickyHeaderService {
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;

    export class StickyHeaderService {
        private scope: HTMLElement;
        private headerDistance: number;
        private shrinkModeActive: boolean;
        private deviceDetectionHelper: DeviceDetectionHelper;
        private gridContainer: HTMLElement;
        private overlay: HTMLElement;
        private respect_glb: boolean = false;

        public init(scope: HTMLElement): void {
            this.scope = scope;
            this.deviceDetectionHelper = DeviceDetectionHelper.instance;
            this.gridContainer = this.scope.querySelector('.grid');
            this.overlay = this.gridContainer.querySelector('.mpc-loading-overlay');

            const gridEmptyHeaders: NodeListOf<HTMLElement> = this.scope.querySelectorAll('.empty-header');
            if (gridEmptyHeaders.length >= 4) {
                return;
            }

            if (this.deviceDetectionHelper.isMobileShop()) {
                this.headerDistance = 400;
                window.addEventListener('scroll', () => { this.handleMobileGridHeaderOnScroll() });
            }
            else {
                this.headerDistance = 600;
                window.addEventListener('scroll', () => { this.handleGridHeaderOnScroll() });
            }

            if (this.gridContainer && this.gridContainer.dataset.portalmandanttoken 
                && this.gridContainer.dataset.portalmandanttoken === "GLB") {
                this.respect_glb = true;
            }
        }

        private handleGridHeaderOnScroll(): void {
            if (!this.gridContainer) {
                return;
            }

            const columnHeaderContainers: NodeListOf<HTMLElement> = this.gridContainer.querySelectorAll('.column-header-container');
            const columnHeaderContainersArray: Array<HTMLElement> = Array.prototype.slice.call(columnHeaderContainers);
            const verticalDistance: number = window.pageYOffset || document.documentElement.scrollTop;
            
            if (this.gridContainer.clientHeight > window.innerHeight || this.shrinkModeActive) {
                for (const columnHeaderContainer of columnHeaderContainersArray) {
                    const headerFadeArea: HTMLElement = columnHeaderContainer.querySelector('.header-fade-area');

                    if (verticalDistance > this.headerDistance) {
                        columnHeaderContainer.classList.add('shrink-header');

                        this.overlay.classList.remove('normal-top-distance');
                        this.overlay.classList.add('top-distance-on-shrink');
                        setTimeout(() => { headerFadeArea.style.opacity = "1"; }, 100);
                        this.shrinkModeActive = true;
                    } else {
                        headerFadeArea.style.opacity = "0";
                        columnHeaderContainer.classList.remove('shrink-header');

                        this.overlay.classList.add('normal-top-distance');
                        this.overlay.classList.remove('top-distance-on-shrink');
                        this.shrinkModeActive = false;
                    }
                }
            }
        }

        private handleMobileGridHeaderOnScroll(): void {
            const gridCarousel: HTMLElement = this.scope.querySelector('.grid-carousel-container');

            if (!gridCarousel)
                return;

            const stickyHeaderContainer: HTMLElement = this.scope.querySelector('.sticky-header-container');

            if (!stickyHeaderContainer)
                return;

            const slideSlots: NodeListOf<HTMLElement> = stickyHeaderContainer.querySelectorAll('.slide-slot');
            const slideSlotsArray: Array<HTMLElement> = Array.prototype.slice.call(slideSlots);
            const verticalDistance: number = window.pageYOffset || document.documentElement.scrollTop;
            const lockedColumnExists: boolean = slideSlotsArray.filter(it => it.classList.contains('locked-column')).length > 0;

            if (verticalDistance > this.headerDistance) {
                stickyHeaderContainer.classList.add('shrink-header');

                if(this.respect_glb)
                    stickyHeaderContainer.classList.add('respect_glb');

                gridCarousel.classList.add('normal-size-carousel');

                if (lockedColumnExists) {
                    gridCarousel.classList.add('display-extras-for-sticky-header');
                    stickyHeaderContainer.classList.add('display-extras-for-sticky-header');
                }
            }
            else {
                stickyHeaderContainer.classList.remove('shrink-header');
                
                if(this.respect_glb)
                    stickyHeaderContainer.classList.remove('respect_glb');

                gridCarousel.classList.remove('normal-size-carousel');

                if (lockedColumnExists) {
                    gridCarousel.classList.remove('display-extras-for-sticky-header');
                    stickyHeaderContainer.classList.remove('display-extras-for-sticky-header');
                }
            }
        }
    }
}